
/* data or computed will need the following properties for this to work: productLine, allSteps, currentStepNumber */
/* also method stepSuccess: function (page, fromstep, tostep) => void has to be implemented */

import StepperMixin from '../StepperMixin';

export default {
  mixins: [ StepperMixin ],
  methods: {
    createAngebot (type, statePath) {
      this.angebotDialog.title = type;
      this.showDialog();
      /* disable comment to skip pdf creation
      this.angebotDialog.pdfUrl = "/?disposition=inline";
      this.angebotDialog.isSuccess = true;
      this.angebotDialog.width = 650;
      return; */
      this.$store.dispatch("submitFormular",{ statePath, formularType: type })
        .then((angebot) => {
          this.angebotDialog.pdfUrl = angebot.pdfpfad + "?disposition=inline";
          this.angebotDialog.isSuccess = true;
          this.angebotDialog.width = 650;
        })
        .catch((err) => {
          console.log(`POST OFFER failed with ${err.status}: ${err.message}`);
          this.angebotDialog.isError = true;
        });
    }
  }
};
